<template>
  <m-layout-mask>
    <m-layout class="left-sidebar-layout" style="width: 240px;" :class="{ compact: compactSidebar }">
      <m-scrollbar>
        <result-menu />
      </m-scrollbar>
    </m-layout>
    <m-layout grow>
      <m-scrollbar id="result-scrollbar">
        <result-list />
      </m-scrollbar>
    </m-layout>
  </m-layout-mask>
</template>

<script>
import MLayoutMask from '@/components/layouts/MLayoutMask'
import MLayout from '@/components/layouts/MLayout'
import MScrollbar from '@/components/MScrollbar'
import MWidgetHead from '@/components/widget/MWidgetHead'
import MHideToggler from '@/components/buttons/MHideToggler'
import ResultMenu from '@/components/results/live/menu/Menu'
import ResultList from '@/components/results/live/list/List'

export default {
  components: { MLayoutMask, MLayout, MScrollbar, MWidgetHead, MHideToggler, ResultMenu, ResultList },
  data () {
    return {
      updateInterval: null,
      change: 0,
      compactSidebar: false
    }
  },
  mounted () {
    let updateResults = () => {
      this.$store.dispatch('results/GET_LIVERESULTS', { params: this.$route.params })
      if (this.change === 0) {
        this.change = 1
      } else {
        this.change = 0
      }
    }
    this.updateInterval = setInterval(function () {
      updateResults()
    }, 500)
  },
  beforeDestroy () {
    clearInterval(this.updateInterval)
  }
}
</script>

<style scoped>
.result-widget-head { margin-left: 10px; }
</style>



// WEBPACK FOOTER //
// src/components/results/ResultsLive.vue